import { useEffect } from 'react';
import { getUserId } from '@client/selectors/helpers/login';
import { startAffiliateLinkImpression } from '@client/slices/entities/affiliates.reducer';
import { getQueryVariable } from '@sda/utils/url';
import { trackAnalytics } from '@client/intercom';
import { AnalyticsEvents } from '@sda/interfaces/queue/analytics';
import { useDispatch, useSelector } from '@client/hooks/redux.hooks';

/**
 * Checks a show for a utm source and adds an impression if it exists.
 */
export const useAffiliateImpression = (showId: string) => {
  const dispatch = useDispatch();

  const utmSource = getQueryVariable('utm_source');
  const userId = useSelector(getUserId);

  useEffect(() => {
    if (showId) {
      if (utmSource) {
        dispatch(startAffiliateLinkImpression({ showId, affiliateLinkSource: utmSource }));
      }

      trackAnalytics(AnalyticsEvents.VIEWED_SHOW, {
        isSignedIn: !!userId,
      });
    }
  }, [dispatch, showId, utmSource, userId]);
};
